import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  GetPermessiList,
  GetSelectedStruttura,
  GetStruttureList,
} from '../services';

/**
 * blocks access when the user lacks the route's required permessi.
 * @returns {boolean} true if access is allowed, false if the route redirects instead.
 */
export const permissionGuard: CanActivateFn = (route) => {
  const router = inject(Router);

  const storedPermission = GetPermessiList();
  const requiredPermissions = route.data['permissions'] as Array<string>;
  const allowAnyStructurePermission =
    route.data['allowAnyStructurePermission'] === true;

  if (
    !requiredPermissions ||
    requiredPermissions.length === 0 ||
    !storedPermission
  )
    return true;

  const hasPermission = storedPermission.some((permission) =>
    requiredPermissions.includes(permission),
  );
  const selectedStruttura = GetSelectedStruttura();
  const hasRealHomeStruttura =
    !!selectedStruttura &&
    (GetStruttureList() || []).some((s) => s.id === selectedStruttura.id);
  if (hasPermission) {
    return true;
  } else if (
    allowAnyStructurePermission &&
    hasRealHomeStruttura &&
    storedPermission.length > 0
  ) {
    return true;
  } else {
    router.navigate(['/404-page']);
    return false;
  }
};
